import * as React from 'react';

export const LoyaltySilverIcon = ({ width = 37, height = 40 }: { width?: number; height?: number }) => (
    <svg
        style={{ flexShrink: 0 }}
        width={width}
        height={height}
        viewBox="0 0 37 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.369 0.48449C17.5035 -0.163439 18.896 -0.16344 20.0305 0.484489L34.339 8.65641C35.4896 9.31352 36.1997 10.5369 36.1997 11.8619V28.1367C36.1997 29.4617 35.4896 30.685 34.339 31.3421L20.0305 39.5141C18.896 40.162 17.5035 40.162 16.369 39.5141L2.06045 31.3421C0.909875 30.685 0.199738 29.4617 0.199738 28.1366V11.8619C0.199738 10.5369 0.909874 9.31353 2.06045 8.65641L16.369 0.48449Z"
            fill="url(#paint0_linear_2516_32598)"
        />
        <path
            d="M11.3564 16.1749L14.4802 17.9173L17.5944 14.2695C17.8332 13.9898 18.2979 13.925 18.6322 14.1248C18.699 14.1647 18.7574 14.2136 18.8051 14.2695L21.9193 17.9173L25.0432 16.1749C25.3851 15.9842 25.8469 16.0615 26.0748 16.3475C26.1728 16.4705 26.2153 16.6187 26.1947 16.7655L24.9723 25.4591C24.9282 25.7725 24.6107 26.0088 24.2334 26.0088H12.1661C11.7889 26.0088 11.4714 25.7725 11.4273 25.4591L10.2049 16.7655C10.1569 16.4241 10.4488 16.1148 10.8568 16.0746C11.0323 16.0573 11.2094 16.0929 11.3564 16.1749Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_2516_32598"
                x1={18.1997}
                y1={-0.00145773}
                x2={37.2872}
                y2={42.2892}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#A6A6A6" />
                <stop offset={1} stopColor="#585151" />
            </linearGradient>
        </defs>
    </svg>
);
